/**
 * Generate personalized share text for announcements.
 * Uses sender's name unless the relationship is crush/secret admirer.
 */
export function getShareText(senderName?: string | null, relationship?: string | null): string {
  const isCrush = relationship === 'crush';
  if (!isCrush && senderName?.trim()) {
    return `${senderName.trim()} has written something meaningful for you — take a look.`;
  }
  return 'Someone has written something meaningful — take a look.';
}
